<template>
  <component
    :is="decideComponent"
    class="uyasd3ap"
    :class="[
      { loading: isLoading },
      { disabled: disabled },
      { rounded: rounded },
      type,
      size
    ]"
    :href="href"
    :to="to"
    :target="target"
    :disabled="disabled"
    tabindex="0"
    @click="$emit('click')"
    @focus="$emit('focus')"
    @blur="$emit('blur')"
  >
    <slot></slot>
    <div class="spinner"></div>
  </component>
</template>


<script>
export default {
  name: "j-button",
  props: {
    type: {
      type: String,
      required: false,
      default: "primary"
    },
    size: {
      required: false,
      default: "medium",
      validator(val) {
        return (
          val === null ||
          ["xsmall", "small", "medium", "large", "xlarge"].includes(val)
        );
      }
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    rounded: {
      type: Boolean,
      required: false,
      default: false
    },
    to: {
      type: String,
      required: false
    },
    href: {
      type: String,
      required: false
    },
    target: {
      type: String,
      default: "_self",
      required: false
    },
    routerTag: {
      type: String,
      required: false,
      default: "router-link"
    }
  },
  computed: {
    decideComponent() {
      if (this.href) return "a";
      if (this.to) return this.routerTag;
      return "button";
    }
  }
};
</script>

<style src="./index.css" scoped />